import { createSelector } from 'reselect';


export const getIsArchiveFetched = (state, props) => state.archive.params.archiveFetched;
export const getIsDownloadFetched = (state, props) => state.archive.params.downloadMsg;
export const getArchiveList = (state, prop) => state.archive.byId
export const getEditedRes = (state, prop) => state.archive.saveEditedResponse
export const getNotification = (state, id) => state.archive.notifications[id]


export const getFilteredArchive = createSelector(
    getArchiveList,
    (Archive) => {
        let filteredArchive = Object.keys(Archive).map(function (key) {
            return Archive[key];
        })
        return filteredArchive;
    }
)

export const getFilteredArchiveForDD = createSelector(
    getArchiveList,
    (Archive) => {
        const keys = Object.keys(Archive)
        let obj = [{
            key: "All",
            value: "All",
            text: "All"
        }]
        keys.map((key) => { 
            obj.push({ key: Archive[key].trans_type, value: Archive[key].trans_type, text: Archive[key].trans_type })
        })
        return obj
    }
)
